import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import { Row, Col, Table, Input, Button, notification,Pagination, Checkbox } from 'antd';
import '../user/userList/userList.css'
import { SpinnerDotted } from 'spinners-react';
import NotifModal from "./notifModal";


function Notification() {
    const [userList, setUserList] = useState([]);
    const [step, setStep] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    function changeState(newUserList){
        setUserList(newUserList)
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }




    const searching = () => {
        if (search.length !== 0) {
            Axios.get(`${Api}user-list-panel?search=${search}&limit=1`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        setStep(1);
                        setUserList(data.data.data);
                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام اپراتور را وارد نمایید")
        }
    }
    //
    // const roleManager = (role) => {
    //     switch (role) {
    //         case 1: return "مدیر"
    //         case 2: return "اپراتور"
    //         case 3: return "مشتری"
    //     }
    // }

    const columns = [

        {
            title: 'شناسه',
            dataIndex: "id",
            key: "id"
        },
        {
            title: 'کد املاک',
            dataIndex: 'codeAmlak',
        },

        {
            title: 'نام و نام خانوادگی',
            dataIndex: "moshaver"

        },
        {
            title: 'اعتبار (روز)',
            // dataIndex: 'validity',
            render: (e) => {return e.validity !=null  ?<p>{ e.validity }</p>:<p>0</p>},

        },

    ];



    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };


    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: true
    };
    const hasSelected = selectedRowKeys.length > 0;


    switch (step) {
        case 0:
            return userList
                ? <>
                    <Row style={{ background: 'white', marginBottom: '10px' }}>
                        <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                            <Input
                                onChange={(e) => { setSearch(e.target.value)}}
                                id="userSerachInput"
                                placeholder='برای جستجو نام کاربر را وارد نمایید...'
                            />
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                            <Button onClick={searching} id='userSearchButton'>جستجوی کاربر</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <NotifModal selectedRowKeys={selectedRowKeys}/>
                            {/*<Button type="primary" disabled={!hasSelected} onClick={() =>{*/}
                            {/*    setStep(2);*/}
                            {/*}} style={{fontSize: "15px", fontFamily: "iranSansBold"}}>پیغام</Button>*/}
                        </Col>
                    </Row>

                    <Table id='userTableList' columns={columns} dataSource={userList} pagination={false} />
                    <Row style={{width:'100%',justifyContent:'center'}}>
                        <Pagination
                            style={{direction:'ltr',marginTop:"20px"}}
                            current={pageNumber}
                            total={totalPage}
                            pageSize={10}
                            onChange={
                                (e)=>{
                                    setPageNumber(e)
                                }
                            } />
                    </Row>

                </>
                :
                <>
                    <p className='orderColumeText' >كاربري در حال حاضر براي نمايش وجود ندارد</p>
                </>

        case 1:
            return (
                userList
                    ? <>
                        <Row style={{ background: 'white', marginBottom: '10px' }}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                                <Input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    id="userSerachInput"
                                    placeholder='برای جستجو نام کاربر را وارد نمایید...'
                                />
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                                <Button onClick={searching} id='userSearchButton'>جستجوی کاربر</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <NotifModal selectedRowKeys={selectedRowKeys} hasSelected={hasSelected}/>
                                {/*<Button type="primary" disabled={!hasSelected} onClick={() =>{*/}
                                {/*    setStep(2);*/}
                                {/*}} style={{fontSize: "15px", fontFamily: "iranSansBold"}}>پیغام</Button>*/}
                            </Col>
                        </Row>

                        <Table  rowSelection={rowSelection} rowKey={record => record.id} id='userTableList' columns={columns} dataSource={userList} pagination={false} />
                        <Row style={{width:'100%',justifyContent:'center'}}>
                            <Pagination
                                style={{direction:'ltr',marginTop:"20px"}}
                                current={pageNumber}
                                total={totalPage}
                                pageSize={10}
                                onChange={
                                    (e)=>{
                                        setPageNumber(e)
                                    }
                                } />
                        </Row>

                    </>
                    :
                    <>
                        <p className='orderColumeText' >كاربري در حال حاضر براي نمايش وجود ندارد</p>
                    </>
            )


    }
}
export default Notification;

